import { createReducer } from "@reduxjs/toolkit";   
import { getGreeterCust, GetGreeterSection, GetGuestCode, GetSalesPerson, GreeterPostDetails } from "./GreeterThunk";

const handleAsyncActions = (builder, action, dataKey, errorKey) => {
    builder
        .addCase(action.pending, (state) => {
            state.loading[dataKey] = true;
            state[dataKey] = null;
            state.error[errorKey] = null;
        })
        .addCase(action.fulfilled, (state, action) => {
            state.loading[dataKey] = false;
            state[dataKey] = action.payload;            
            state.error[errorKey] = null;
        })
        .addCase(action.rejected, (state, action) => {
            state.loading[dataKey] = true;
            state.error[errorKey] = action.payload;
        })
};

const initialState = {
    GetGreeterCustData: null,
    GetSalesPersonData:null,
    GreeterSectionData:null,
    PostGreeter:null,
    fetchGuestCode:null,

    loading: {
        GetGreeterCustData: false,
        GetSalesPersonData:false,
        GreeterSectionData:false,
        PostGreeter:false,
        fetchGuestCode:false,
    },

    error: {
        GetGreeterCustError: null,
        GetSalesPersonError:null,
        GreeterSectionError:null,
        PostGreeterError:null,
        fetchGuestCodeError:null,
    },
};

export const GreeterReducer = createReducer(initialState, (bulider) => {
    handleAsyncActions(bulider, getGreeterCust, "GetGreeterCustData","GetGreeterCustError");
    handleAsyncActions(bulider, GetSalesPerson, "GetSalesPersonData","GetSalesPersonError");
    handleAsyncActions(bulider, GetGreeterSection, "GreeterSectionData","GreeterSectionError");
    handleAsyncActions(bulider, GreeterPostDetails, "PostGreeter","PostGreeterError");
    handleAsyncActions(bulider, GetGuestCode, "fetchGuestCode","fetchGuestCodeError");

});

export default GreeterReducer;